/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AccesoMenuMSL } from './accesoMenuMSL';

export interface AccesoOtpMS { 
    numeroCliente?: number;
    secuencialEmpresa?: number;
    identificacion?: string;
    id?: string;
    avatarImagen?: string;
    tipoIdentificacionNombre?: string;
    nombre?: string;
    nombreUsuario?: string;
    correo?: string;
    telefono?: string;
    fechaCreacion?: string;
    ultimaActividad?: string;
    token?: string;
    refrescarToken?: string;
    otpValido?: boolean;
    bloqueo?: boolean;
    fechaActualizacion?: Date;
  menus?: Array<AccesoMenuMSL>;
  usaClaveDigital?: boolean;
  dispositivo?: boolean;
}
